const getters = {
  propertyData: state => state.property,
  homepageData: state => state.homepage,
  galleryData: state => state.repos,
  getMapData: (state) => state.mapData,
  processedBanners: state => {
    try {
      return state.banners
    } catch (err) {
      return []
    }
  },
  processedStores: state => {
    try {
      return state.stores
    } catch (err) {
      return []
    }
  },
  processedJobs: state => {
    try {
      return state.jobs
    } catch (err) {
      return []
    }
  },
  processedEvents: state => {
    try {
      return state.events
    } catch (err) {
      return []
    }
  },
  processedNews: state => {
    try {
      return state.news
    } catch (err) {
      return []
    }
  },
  processedPromotions: state => {
    try {
      return state.promotions
    } catch (err) {
      return []
    }
  },
  processedCategories: state => {
    try {
      return state.categories
    } catch (err) {
      return []
    }
  },
  findStoreBySlug: state => slug => {
    try {
      let stores = state.stores
      return stores.find(store => useLowerCase(store.slug) === useLowerCase(slug))
    } catch (err) {
      return []
    }
  },
  findPageBySlug: (state) => {
    try {
      const pages = state.pages
      return (slug) => pages.find((page) => page.slug === slug)
    } catch (error) {
      return [] 
    }
  },
  findBannerByName(state) {
    return (name) => {
      try {
        const banners = this.processedBanners
        return banners.find(banner => banner.name === name) || null
      } catch (error) {
        console.error("Error in findBannerByName:", error)
        return null
      }
    }
  },
  findBlogByName(state) {
    return (name) => {
      try {
        const blogs = state.blogs
        return blogs.find((blog) => blog.name === name) || null
      } catch (error) {
        console.error("Error in findBlogByName:", error)
        return null
      }
    }
  },
  findBlogBySlug(state) {
    return (name) => {
      try {
        const blogs = state.blogs
        return blogs.find((blog) => useLowerCase(blog.slug) === useLowerCase(slug)) || null
      } catch (error) {
        console.error("Error in findBlogBySlug:", error)
        return null
      }
    }
  },
}

export default getters
